<template>
	<div>
		<label>
			<span>Координаты захоронения</span>
			<input v-model="geo" type="text" name="geo" class="uk-input" placeholder="Координаты захоронения">
			<p><small>Не знаете координаты? <a href="#" type="button">Выберите место на карте</a></small></p>
			<div uk-drop="mode: click;pos: top-center">
				<div id="mapblock" class="uk-card uk-card-body uk-card-default mapblock"></div>
			</div>
		</label>
	</div>
</template>

<script>
  import 'leaflet'

  export default {
    name: "set-coord",

    data() {
      return {
        myMap: '',
        bounds: [],
        map_coord: [55.831226, 49.144890],
	      geo: ''
      }
    },
    props: {
      in_geo: ''
    },
    methods: {
      map() {
        let coord = this.map_coord;
	      let app = this;
	      let marker;
        /*L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          //attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);*/


        let googleStreets = L.tileLayer('http://{s}.google.com/vt/lyrs=m&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        });

        let googleHybrid = L.tileLayer('http://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',{
          maxZoom: 20,
          subdomains:['mt0','mt1','mt2','mt3']
        });

        //let map = L.map('mapblock').setView(this.map_coord, 17);
        let map = L.map('mapblock', {
          center: coord,
          zoom: 17,
          layers: [googleStreets, googleHybrid]
        });

        let baseMaps = {
          "Схема": googleStreets,
          "Спутник": googleHybrid
        };

        L.control.layers(baseMaps, '', {
          collapsed: false
        }).addTo(map);

        /*L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
          attribution: '&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(map);*/

        //googleHybrid.addTo(map);
        L.control.locate({
          strings: {
            title: "Определить моё местоположение"
          }
        }).addTo(map);

       /* map.on("click", function (event) {
          console.log("Coordinates: " + event.latlng.toString());
          L.marker(event.latlng, {draggable:true}).addTo(map);
        });*/
        //this.addGeoToMap();
	      if(coord){
          L.marker(this.map_coord).addTo(map);
	      }
        let onClick = function(e) {
          map.off('click', onClick);
	        if(!marker){
            marker = new L.marker(e.latlng,{draggable: true}).addTo(map);
	        }
          let lat = e.latlng.lat;
          let lon = e.latlng.lng;
          app.geo = [lat, lon];
          //alert("Lat, Lon : " + lat + ", " + lon);

          marker.on('dragend', function(event) {
            var position = marker.getLatLng();
            marker.setLatLng(position, {
              draggable: 'true'
            }).bindPopup(position).update();
            app.geo = [position.lat, position.lng];
            /*$("#Latitude").val(position.lat);
						$("#Longitude").val(position.lng).keyup();*/
          });
        };


        /*var marker = new L.marker(curLocation, {
          draggable: 'true'
        });

        marker.on('dragend', function(event) {
          var position = marker.getLatLng();
          marker.setLatLng(position, {
            draggable: 'true'
          }).bindPopup(position).update();
          $("#Latitude").val(position.lat);
          $("#Longitude").val(position.lng).keyup();
        });

        $("#Latitude, #Longitude").change(function() {
          var position = [parseInt($("#Latitude").val()), parseInt($("#Longitude").val())];
          marker.setLatLng(position, {
            draggable: 'true'
          }).bindPopup(position).update();
          map.panTo(position);
        });*/

        map.on('click', onClick);

      },
    },
    mounted() {
      this.map();
      if(this.in_geo) {
        this.map_coord = this.in_geo;
        this.geo = this.in_geo;
      }
    }
  }
</script>